import React, { useEffect, useState } from 'react';
import { PhoneIcon, MenuIcon, XIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md py-3' : 'bg-white py-4'}`} data-id="element-118">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-119">
        <div className="flex justify-between items-center" data-id="element-120">
          {/* Logo */}
          <div className="flex items-center" data-id="element-121">
            <span className="text-2xl font-bold text-viridia-600 tracking-tight" data-id="element-122">
              Viridia Analytics
            </span>
          </div>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center gap-4" data-id="element-123">
            <Button variant="primary" size="sm" className="flex items-center gap-2" onClick={() => window.location.href = 'tel:6233000708'} data-id="element-124">
              <PhoneIcon className="w-4 h-4" data-id="element-125" />
              Call the AI Demo Now
            </Button>
            <Button variant="secondary" size="sm" onClick={() => window.open('https://api.viridiaanalytics.com/payment-link/699612346c8c04e29116c945', '_blank')} data-id="element-126">
              Get Started Today
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-2" data-id="element-127">
            <a href="tel:6233000708" className="p-2 bg-viridia-100 text-viridia-600 rounded-full hover:bg-viridia-200 transition-colors" aria-label="Call Now" data-id="element-128">
              <PhoneIcon className="w-5 h-5" data-id="element-129" />
            </a>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 text-gray-600 hover:text-viridia-600 transition-colors" aria-label="Toggle menu" data-id="element-130">
              {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-131" /> : <MenuIcon className="w-6 h-6" data-id="element-132" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-133">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-134">
            <div className="px-4 py-6 space-y-4 flex flex-col" data-id="element-135">
              <Button variant="primary" size="lg" className="w-full justify-center gap-2" onClick={() => window.location.href = 'tel:6233000708'} data-id="element-136">
                <PhoneIcon className="w-5 h-5" data-id="element-137" />
                Call the AI Demo Now
              </Button>
              <Button variant="secondary" size="lg" className="w-full justify-center" onClick={() => window.open('https://api.viridiaanalytics.com/payment-link/699612346c8c04e29116c945', '_blank')} data-id="element-138">
                Get Started for $697/month Today
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}